const ellipsisTextOverflowStyles = {
  overflow: 'hidden',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};

const ellipsisTextOverflowFewRowsStyles = (rows = 2) => ({
  ...ellipsisTextOverflowStyles,
  whiteSpace: 'pre-line',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
});

export { ellipsisTextOverflowStyles, ellipsisTextOverflowFewRowsStyles };
